<fieldset class="group" [formGroup]="group()">
    <legend>{{ "FLIGHT_LIST.groups.pilots" | translate }}</legend>
    <div class="fields pairs">
        <label class="field">
            <span class="label required">{{ "FLIGHT_LIST.pilot" | translate }}</span>
            <kendo-combobox
                formControlName="pilotId"
                [data]="pilots()"
                textField="name"
                valueField="id"
                [valuePrimitive]="true"
                [kendoDropDownFilter]="{ operator: 'contains' }"
            ></kendo-combobox>
            @if (group().controls.pilotId.invalid) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.required" | translate }}</span>
            }
        </label>
        <label class="field">
            <span class="label required">{{ "FLIGHT_LIST.role" | translate }}</span>
            <kendo-combobox formControlName="pilotRoleId" [data]="lookups().pilotRoles" textField="abbreviation" valueField="id" [valuePrimitive]="true">
                <ng-template kendoComboBoxItemTemplate let-role>
                    <span class="option"
                        ><strong>{{ role.abbreviation }}</strong
                        ><small>{{ role.name }}</small></span
                    >
                </ng-template>
            </kendo-combobox>
            @if (group().controls.pilotRoleId.invalid) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.required" | translate }}</span>
            }
        </label>
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.copilot" | translate }}</span>
            <!-- A copilot may be someone the organization has not registered: the name typed is kept. -->
            <kendo-combobox
                formControlName="coPilot"
                [data]="coPilots()"
                textField="name"
                valueField="name"
                [allowCustom]="true"
                [valueNormalizer]="typedCoPilot"
                [kendoDropDownFilter]="{ operator: 'contains' }"
            ></kendo-combobox>
            @if (group().hasError("coPilot")) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.coPilot" | translate }}</span>
            }
        </label>
        <label class="field">
            <span class="label required">{{ "FLIGHT_LIST.role" | translate }}</span>
            <kendo-combobox formControlName="coPilotRoleId" [data]="coPilotRoles()" textField="abbreviation" valueField="id" [valuePrimitive]="true">
                <ng-template kendoComboBoxItemTemplate let-role>
                    <span class="option"
                        ><strong>{{ role.abbreviation }}</strong
                        ><small>{{ role.name }}</small></span
                    >
                </ng-template>
            </kendo-combobox>
            @if (group().hasError("coPilotRole")) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.coPilotRole" | translate }}</span>
            }
        </label>
    </div>
</fieldset>
